import React from 'react'

const FilterRangeCustom = () => <div>sss</div>

export default FilterRangeCustom
